import { render, staticRenderFns } from "./popover.vue?vue&type=template&id=4e370ff9&scoped=true&lang=pug&"
import script from "./popover.vue?vue&type=script&lang=ts&"
export * from "./popover.vue?vue&type=script&lang=ts&"
import style0 from "./popover.vue?vue&type=style&index=0&id=4e370ff9&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e370ff9",
  null
  
)

export default component.exports